import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useRouter } from '../../common/RouterHooks';
import NoVehicleContainer, { NoVehicleProps } from './containers/NoVehicleContainer';

const NoVehicle: React.FC<NoVehicleProps> = (props) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <React.Fragment>
            <NoVehicleContainer {...props} routeProps={routeProps}>
                {(containerProps) =>
                    <React.Fragment>
                        <div className={'margin-bottom-15'}>
                            <h3>{t('common:vehicleNotFound.header')}</h3>
                            <span>{t('common:vehicleNotFound.description')}</span>
                        </div>
                        {containerProps.showRedirectButton ?
                            <div className={classNames(['grid-x', 'align-right'])}>
                                <button type="button" className={classNames(['button', 'bttSubscrever'])} onClick={containerProps.onClick}>{t('common:vehicleNotFound.profileButton')}</button>
                            </div>
                            :
                            ''
                        }
                    </React.Fragment>
                }
            </NoVehicleContainer>
        </React.Fragment>
    );
};

export default NoVehicle;
